import { EditFeatureState } from "../editFeature.reducer";
import { IPartialReducer } from "../../../core/core-redux/reduxTypes";

export const geometryChangedPartialReducer: IPartialReducer<EditFeatureState> = (state, action) => {
    return {
        ...state,
        options: {
            ...state.options,
            editPaused: action.shouldWaitForPortal,
        },
    };
};
